// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.spinner-wrapper {\n    width: 100%;\n    z-index: 2;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: fixed;\n}\n.gv-progress-bar {\n    z-index: 2;\n    left: 50%;\n    top: 50%;\n    margin-top: -50px!important; /* Negative half of height. */\n    margin-left: -50px!important; /* Negative half of width. */\n    position: fixed!important;\n}\n", ""]);
// Exports
module.exports = exports;
